import { getWhatsAppHistoryMeta, isWhatsAppSyncedOutgoing } from './whatsappMessagePresentation';

import { whatsappRevocation } from './whatsappRevocation';

const attributes = message => message.contentAttributes ?? message.content_attributes ?? {};
const type = message => message.messageType ?? message.message_type;
const time = message => getWhatsAppHistoryMeta(message)?.timestamp ?? message.createdAt ?? message.created_at;
const day = seconds => {
  const date = new Date(seconds * 1000);
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

// Input is the already source-time-ordered visible conversation. Do not change
// transport privacy, delivery state, bubble grouping, or message ordering here.
export function whatsappTimestampGroups(messages) {
  let previous = null;
  let afterRevocation = false;
  return messages.map(message => {
    const attrs = attributes(message);
    const side = type(message);
    // A revoked row has its own notice, but must not hide the next visible time.
    if (whatsappRevocation(attrs)) {
      afterRevocation = true;
      return false;
    }
    if (![0, 1, 3].includes(side)) return true;
    if (message.private && !isWhatsAppSyncedOutgoing(message)) return true;
    const current = { side: side === 0 ? 0 : 1, time: time(message) };
    const valid = Number.isFinite(current.time) && current.time > 0;
    const show = !previous || afterRevocation || !valid ||
      !Number.isFinite(previous.time) || previous.time <= 0 ||
      previous.side !== current.side ||
      current.time < previous.time ||
      current.time - previous.time > 600 ||
      day(current.time) !== day(previous.time);
    previous = current;
    afterRevocation = false;
    return show;
  });
}
